import store from '../store/index.js'
import { post } from '../services/index.js'

const UNAUTHORIZED = 401

function merchantReference() {
  return {
    reference: 'merchant',
    reference_id: store.getters.getMerchant.id
  }
}

function toResult(response, invalidCredentialsMessage) {
  if (response.status === UNAUTHORIZED) {
    return { isSuccess: false, data: null, message: invalidCredentialsMessage }
  }

  const body = response.data || {}
  const isSuccess = body.success === true || !!body.access_token
  return {
    isSuccess: isSuccess,
    data: body,
    message: isSuccess ? '' : body.message || ''
  }
}

/**
 * post() resolves (never rejects) on a 401 from auth/token, so the status has to
 * be inspected here rather than caught.
 * @param {{email: string, password: string, invalidCredentialsMessage: string}} params
 * @returns {Promise<{isSuccess: boolean, data: object, message: string}>}
 */
export function loginRequest(params) {
  const payload = Object.assign({
    username: params.email,
    password: params.password,
    fcm_token: ''
  }, merchantReference())

  return post('BASE', 'auth/token', payload).then(function (response) {
    return toResult(response, params.invalidCredentialsMessage)
  })
}

/**
 * The register endpoint issues tokens directly — there is no password field.
 * @param {object} form
 * @returns {Promise<{isSuccess: boolean, data: object, message: string}>}
 */
export function registerRequest(form) {
  const payload = Object.assign({
    gender: form.gender,
    first_name: form.first_name,
    last_name: form.last_name,
    email: form.email,
    address: form.address,
    merchant_id: store.getters.getMerchant.id
  }, merchantReference())

  if (form.phone_number) {
    payload.phone = form.dial_code.dial_code + form.phone_number
  }

  return post('BASE', 'email-register-user', payload).then(function (response) {
    return Object.assign(toResult(response, ''), { payload: payload })
  })
}

export function requestResetOtp(email) {
  const payload = Object.assign({ username: email }, merchantReference())
  return post('BASE', 'reset-password', payload).then(function (response) {
    return toResult(response, '')
  })
}

export function submitNewPassword(params) {
  const payload = Object.assign({
    username: params.email,
    otp: params.otp,
    new_password: params.password,
    re_new_password: params.confirmPassword
  }, merchantReference())

  return post('BASE', 'reset-password-val', payload).then(function (response) {
    return toResult(response, '')
  })
}



// WEBPACK FOOTER //
// ./src/utils/authApi.js